module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/suede@2x_fdffa8.jpg";